import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Button, Dropdown, Form, Grid, Label } from 'semantic-ui-react';
import { userActions } from '../../actions/user.actions';
import { teamActions } from '../../actions/team.actions';

class TeamEditScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      members_id: null,
      description: '',
      submitted: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(userActions.getCompanyUsers());
    dispatch(teamActions.getById(match.params.id)).then(() => {
      const { teams } = this.props;
      this.setState({
        name: teams.item.name,
        description: teams.item.description,
        members_id: _.map(teams.item.users, (item) => item.id),
      });
    });
  }

  handleChange(e, data) {
    if (data) {
      this.setState({ [data.name]: data.value });
    } else {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { name, members_id, description } = this.state;

    const { dispatch, match } = this.props;
    if (name && description && members_id) {
      dispatch(
        teamActions.update(
          match.params.id,
          {
            name,
            description,
            users: members_id,
          },
          this.props.history,
        ),
      );
    }
  }

  render() {
    const { users, loading } = this.props;
    const { name, description, members_id, submitted } = this.state;

    let userOptions = [];

    if (users && users.companyUsers !== undefined) {
      userOptions = users.companyUsers.data.map((item) => {
        return { key: item.id, value: item.id, text: item.name };
      });
    }

    return (
      <Fragment>
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <h1>Editar Time</h1>
          </Grid.Column>
        </Grid>
        <Form onSubmit={this.handleSubmit} loading={loading}>
          <Form.Field>
            <label>Nome</label>
            <input
              name="name"
              placeholder="Nome do Time"
              value={name}
              onChange={this.handleChange}
            />
            {submitted && !name && (
              <Label basic color="red" pointing>
                Nome é requerido
              </Label>
            )}
          </Form.Field>
          <Form.Field>
            <label>Descrição</label>
            <input
              name="description"
              placeholder="Descrição"
              value={description}
              onChange={this.handleChange}
            />
            {submitted && !description && (
              <Label basic color="red" pointing>
                Descrição é requerido
              </Label>
            )}
          </Form.Field>
          <Form.Field>
            <label>Membros</label>
            <Dropdown
              name="members_id"
              onChange={(event, data) => this.handleChange(true, data)}
              placeholder="Membros"
              fluid
              multiple
              search
              selection
              options={userOptions}
              value={members_id}
            />
          </Form.Field>
          <Button primary type="submit">
            Atualizar
          </Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, teams } = state;
  return {
    users,
    loading: users.loading || false,
    teams,
  };
}

const connectedTeamEditScreen = connect(mapStateToProps)(TeamEditScreen);
export { connectedTeamEditScreen as TeamEditScreen };
